import { Button, Input, Text } from "@ttc3k/trekker";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Box, Flex } from "styled-system/jsx";

type PromoCodeInputProps = {
  formValidationMessage: string | null;
  isValidationError: boolean;
};

export const PromoCodeInput = ({
  formValidationMessage,
  isValidationError,
}: PromoCodeInputProps) => {
  const name = "promoCode";
  const { register, control } = useFormContext();
  const { fieldState } = useController({ name, control });

  const { t } = useTranslation("booker", { keyPrefix: "CHECKOUT.PROMO_CODE" });

  const props = {
    label: t("TITLE"),
    bg: "white",
    ...register(name),
    ...(fieldState.error || isValidationError
      ? { "data-invalid": true, "aria-invalid": true }
      : {}),
  };
  return (
    <Box>
      <Flex justify={"space-between"} gap={"200"} w={"full"}>
        <Input {...props} />
        <Button type={"submit"} size={"md"} alignSelf="flex-end" mb={"50"}>
          {t("APPLY")}
        </Button>
      </Flex>
      {(formValidationMessage || fieldState.error?.message) && (
        <Text
          as={"span"}
          color={
            isValidationError || fieldState.error
              ? "text.error.dark"
              : "text.mid"
          }
          visual={"smallMedium"}
        >
          {formValidationMessage ?? fieldState.error?.message}
        </Text>
      )}
    </Box>
  );
};
